import type { KycStatus } from "@/types/kyc";
import { KYC_STATUS_META } from "../data";

export default function KycStatusBadge({ status }: { status?: KycStatus | string | null }) {
  if (!status) {
    return (
      <span className="inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium bg-[#F1F5F9] text-[#475569]">
        Not Started
      </span>
    );
  }

  const raw = String(status).trim();
  const normalizedKey = raw.toUpperCase().replace(/[\s\-]+/g, "_") as KycStatus;

  let resolvedKey: KycStatus = normalizedKey;
  if ((normalizedKey as string) === "PENDING" || (normalizedKey as string) === "IN_REVIEW") {
    resolvedKey = "UNDER_REVIEW";
  } else if ((normalizedKey as string) === "VERIFIED") {
    resolvedKey = "APPROVED";
  } else if ((normalizedKey as string) === "NOT_VERIFIED") {
    resolvedKey = "NOT_STARTED";
  }

  const meta = KYC_STATUS_META[resolvedKey] || {
    label: raw.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    text: "text-[#475569]",
    bg: "bg-[#F1F5F9]",
  };

  return (
    <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${meta.bg || "bg-[#F1F5F9]"} ${meta.text || "text-[#475569]"}`}>
      {meta.label || raw}
    </span>
  );
}